import React, { useState } from 'react';
import DataTable from '../../components/DataTable';
import PageWrapper from '../../components/PageWrapper';
import { useTableDataWithPost } from '../../hooks/useTableWithPost';
import { APIManagementData } from '../../config/tableConfigs';
import PageWrapperForm from '../../components/PageWrapperForm';
import APIManagerFormModal from './components/apiManagerFormModal';
import DeleteModal from '../../components/DeleteModal';
import { useSession } from 'hooks/useSession';
import { fetchWrapper } from 'utils/apiFetch';

// Add this CSS either in your stylesheet or as a <style> tag
const loaderStyle = `
  .page-loader-overlay {
    position: fixed;
    inset: 0;
    background: rgba(255, 255, 255, 0.6);
    z-index: 99999;
    display: flex;
    align-items: center;
    justify-content: center;
    backdrop-filter: blur(2px);
  }
`;

const APIManagementPage = () => {
  const [modalShow, setModalShow] = useState(false);
  const [modalMode, setModalMode] = useState("add");
  const [selectedUser, setSelectedUser] = useState(null);
  const [refresh, setRefresh] = useState(0);
  const [toast, setToast] = useState({ show: false, message: '', type: 'success' });
  const { userid } = useSession();
  const [statusLoadingId, setStatusLoadingId] = useState(null); // ✅ track loading row
  const showToast = (message, type = 'success') => {
    setToast({ show: true, message, type });
    setTimeout(() => setToast({ show: false, message: '', type: 'success' }), 3000);
  };

  const handleAddUser = () => {
    setModalMode("add");
    setSelectedUser(null);
    setModalShow(true);
  };

  const formdata = new FormData();
  formdata.append("action", "GET");
  formdata.append("userid", userid);

  const tableData = useTableDataWithPost(
    "https://pro.mokshiq.in/api_manager_action",
    APIManagementData,
    formdata, refresh
  );

  const handleView = (report) => {
    console.log("Viewing report:", report);
  };

  const handleEditUser = (user) => {
    setModalMode("edit");
    setSelectedUser(user);
    setModalShow(true);
  };

  const handleDelete = (user) => {
    setSelectedUser(user);
    setTimeout(() => {
      const modalEl = document.getElementById("deleteapi1");
      if (modalEl) {
        const modal = window.bootstrap.Modal.getOrCreateInstance(modalEl);
        modal.show();
      }
    }, 100);
  };

  const handleExport = (selectedIds) => {
    console.log("Exporting selected data:", selectedIds);
    alert(`Exporting ${selectedIds.length} selected records`);
  };

  const handleDeleteSelected = (selectedIds) => {
    if (
      window.confirm(`Are you sure you want to delete ${selectedIds.length} records?`)
    ) {
      console.log("Deleting selected records:", selectedIds);
    }
  };
  const handleFormSuccess = () => {
    debugger
    console.log("handleFormSuccess called - refreshing data..."); // ✅ Debug log
    setRefresh((prev) => prev + 1);
    setModalShow(false)
  };

  // ✅ Status toggle handler
  const handleChangeStatus = async (user) => {
    if (statusLoadingId === user.id) return; // prevent double-click

    setStatusLoadingId(user.id);
    console.log(user.Status);
    try {
      const formdata = new FormData();
      formdata.append("action", "changeStatus");
      formdata.append("userid", userid);
      formdata.append("id", user.id);                          // adjust field name if needed
      formdata.append("status", user.Status === false ? "True" : "False");   // toggle status

      const result = await fetchWrapper("https://pro.mokshiq.in/api_manager_action", {
        method: "POST",
        body: formdata,
      });



      if (result.status) {
        showToast(`Status changed to ${user.Status === true ? 'Inactive' : 'Active'} successfully!`, 'success');
        setRefresh((prev) => prev + 1);
      } else {
        showToast(result.data || "Failed to change status.", 'danger');
      }
    } catch (error) {
      console.error("Status change error:", error);
      showToast("Something went wrong. Please try again.", 'danger');
    }
    finally {
      setStatusLoadingId(null); // ✅ hide loader regardless of outcome
    }
  };

  // ✅ Handle successful deletion
  const handleDeleteSuccess = () => {
    console.log("Scheme deleted successfully, refreshing data...");
    setRefresh((prev) => prev + 1);
  };

  return (
    <div>
      <style>{loaderStyle}</style>

      {/* ✅ Full-page loader overlay */}
      {statusLoadingId && (
        <div className="page-loader-overlay">
          <div className="text-center">
            <div
              className="spinner-border text-primary"
              style={{ width: '3rem', height: '3rem' }}
              role="status"
            />
            <div className="mt-2 fw-semibold text-primary">Please wait...</div>
          </div>
        </div>
      )}
      <PageWrapperForm config={APIManagementData} handleOnclick={handleAddUser} buttonTitle={"Add API"}>
        <DataTable
          config={APIManagementData}
          tableData={tableData}
          onView={handleChangeStatus}
          onEdit={handleEditUser}
          onDelete={handleDelete}
          onExport={handleExport}
          onDeleteSelected={handleDeleteSelected}
        />
      </PageWrapperForm>

      {/* ✅ Fixed modal usage */}
      <APIManagerFormModal
        show={modalShow}
        onClose={() => setModalShow(false)}
        mode={modalMode}
        userData={selectedUser}
        onSuccess={handleFormSuccess}
      />

      <DeleteModal
        deleteid={selectedUser}

        id="deleteapi1"
        title="Delete API"
        message="Are you sure you want to delete this api?"
        apiUrl="https://pro.mokshiq.in/api_manager_action"
        onSuccess={handleDeleteSuccess}
      />
    </div>
  );
};

export default APIManagementPage;
